import { Components, Services, Types } from '@sendum/core'
import React, { forwardRef, useCallback, useImperativeHandle, useMemo, useRef, useState } from 'react'

import s from './Pallet.module.scss'

export interface IConfirmCompletingModalRef {
    open: (palleet: Types.Pallet) => void
    close: () => void
}

interface IProps {
    onCompleted: () => void
}

export const ConfirmCompletingModal = forwardRef<IConfirmCompletingModalRef, IProps>(({ onCompleted }, ref) => {
    const [msg, setMsg] = useState<string>('')
    const [palletId, setPalletId] = useState<string>('')
    const [isLoading, setLoading] = useState<boolean>(false)

    const modalRef = useRef<Components.IModalRef>(null)

    const complete = useCallback(() => {
        setLoading(true)
        void Services.API.WidgetsApi.updatePallet(palletId, { IsMarkedCompleted: 1 }).then(() => {
            onCompleted()
            setLoading(false)
            modalRef.current?.close()
        })
    }, [onCompleted, palletId])

    const actions = useMemo<Components.IAction[]>(
        () => [
            { title: 'Complete', variant: 'primary', func: complete },
            { title: 'Cancel', variant: 'cancel', func: () => modalRef.current?.close() }
        ],
        [complete]
    )

    useImperativeHandle(ref, () => ({
        open(pallet: Types.Pallet) {
            setMsg(`Batch ${pallet.Batch.BatchNumber} pallet number ${pallet.PalletNumber} is complete`)
            setPalletId(pallet.PalletId)
            setLoading(false)
            modalRef.current?.open()
        },
        close() {
            modalRef.current?.close()
        }
    }))

    return (
        <Components.Modal ref={modalRef} title="Completing" actions={actions} width={400} testId="completing-modal">
            <div className={`${s.Pallet} ${s.Pallet__inModal}`}>
                {isLoading && <Components.Loader className={s.Pallet__loader} />}
                <div style={{ margin: '16px 16px 0 16px' }}>{msg}</div>
            </div>
        </Components.Modal>
    )
})
